import { MaterialModule } from '../material.module';
import { MainFormModalModule } from '../components/main-form-modal/main-form-modal.mdl';
import { DateInputModule } from '../components/dateInput/date-input.mdl';
import { FooterEditButtonsMdl } from '../components/footer-edit-buttons/footer-edit-buttons.mdl';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PageHeadingModule } from '../components/page-heading/page-heading.mdl';
import { PanelBoxModule } from '../components/panel-box/panel-box.mdl';
import { ModelInfoModule } from '../components/model-info/model-info.mdl';
import { CustomToolTipModule } from '../components/custom-tool-tip/custom-tool-tip.mdl';
import { AppOptionEdit } from './app-option-edit.cmp';
import { AppOptionsRoutes } from './app-options.routing';
import { AppOptionsData } from './app-options.data';


@NgModule({
	imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
		PageHeadingModule,
		PanelBoxModule,
		FooterEditButtonsMdl,
		DateInputModule,
		RouterModule.forChild(AppOptionsRoutes),
		MaterialModule,
		MainFormModalModule,
    ModelInfoModule,
    CustomToolTipModule

	],
	declarations: [
		AppOptionEdit
	],
	exports: [
		AppOptionEdit
	],
	providers: [
		AppOptionsData
	]
})
export class AppOptionsMdl { }

